export default "__VITE_ASSET__F6sZmGPd__"